import { useCallback } from "react"
import { toast } from "sonner"
import { invariant } from "@holigral/shared/utils"
import { useChangeEmailMutation, useGetMeQuery } from "./api"
import { VerificationStatus } from "@/auth"
import { useT } from "@/i18n"

export default () => {
  const { t } = useT("auth")
  const [changeEmail] = useChangeEmailMutation()
  const { data: me, isLoading } = useGetMeQuery()

  return useCallback(async () => {
    if (isLoading) {
      return
    }
    invariant(me?.email)
    invariant(me.verificationStatus !== VerificationStatus.Verified)

    await changeEmail({ email: me.email })

    toast.success(t("verificationEmailSent"))
  }, [changeEmail, isLoading, me, t])
}
